export default __webpack_public_path__ + "static/media/img8.f4009ad9.svg";